var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _line, _line2, _line3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyberSecurityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 19.5,
    r: 8,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 18H15L15 23H22V18ZM15 17C14.4477 17 14 17.4477 14 18V23C14 23.5523 14.4477 24 15 24H22C22.5523 24 23 23.5523 23 23V18C23 17.4477 22.5523 17 22 17H15Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 25.5,
    r: 2,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.75,
    cy: 2.5,
    r: 2,
    transform: "rotate(90 11.75 2.5)",
    stroke: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    transform: "matrix(-1 0 0 1 37.5 23)",
    stroke: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 14.25 37.5)",
    stroke: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 18.5,
    r: 2,
    stroke: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.75,
    cy: 2.5,
    r: 2,
    transform: "rotate(90 18.75 2.5)",
    stroke: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    transform: "matrix(-1 0 0 1 37.5 16)",
    stroke: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 21.25 37.5)",
    stroke: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 11.5,
    r: 2,
    stroke: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.75,
    cy: 2.5,
    r: 2,
    transform: "rotate(90 25.75 2.5)",
    stroke: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    transform: "matrix(-1 0 0 1 37.5 9)",
    stroke: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 28.25 37.5)",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18.5,
    x2: 11,
    y2: 18.5,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.75,
    y1: 4,
    x2: 18.75,
    y2: 11,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 7,
    y2: -0.5,
    transform: "matrix(-1 0 0 1 33.5 19)",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 33.5L18.75 27",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12H8.58579C8.851 12 9.10536 12.1054 9.29289 12.2929L11.5 14.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 4.5L25.25 8.58579C25.25 8.851 25.1446 9.10536 24.9571 9.29289L22.25 12",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 12H28.9142C28.649 12 28.3946 12.1054 28.2071 12.2929L25.5 15",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 33L25.25 28.9142C25.25 28.649 25.1446 28.3946 24.9571 28.2071L23 26.25",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 26H8.58579C8.851 26 9.10536 25.8946 9.29289 25.7071L11.5 23.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.5L11.25 8.58579C11.25 8.851 11.3554 9.10536 11.5429 9.29289L14.5 12.25",
    stroke: "white",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26H28.9142C28.649 26 28.3946 25.8946 28.2071 25.7071L26 23.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 33L11.25 28.9142C11.25 28.649 11.3554 28.3946 11.5429 28.2071L13.75 26",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.25,
    y: 19.75,
    width: 0.5,
    height: 1.5,
    rx: 0.25,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.5V16C21 15.4477 20.5523 15 20 15H17C16.4477 15 16 15.4477 16 16V17.5",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberSecurityIcon);
export default __webpack_public_path__ + "static/media/cyberSecurityIcon.1ff6bf62d6b9e33dc6fb0e242bc12aa2.svg";
export { ForwardRef as ReactComponent };